import BlignyLogo from '@/assets/BlignyLogo.png';
import { LandingPageFooter } from '@/pages/onboarding/LandingPageFooter';

interface EtpSommeilAccueilPageProps {
  onNext: () => void;
}

export const EtpSommeilAccueilPage = ({
  onNext,
}: EtpSommeilAccueilPageProps) => {
  return (
    <>
      <div className="flex-1 flex flex-col items-center justify-center gap-4 mt-4">
        <img src={BlignyLogo} alt="Bligny Logo" className="w-60" />
        <p className="text-1.5xl text-center font-medium">
          Bilan Éducatif Partagé
        </p>
        <p className="text-center text-sm font-light leading-5">
          Nous vous remercions du temps consacré à ce questionnaire. Un
          entretien à distance avec une infirmière en éducation thérapeutique
          sera ensuite planifié afin de compléter ce bilan.
        </p>
      </div>

      <LandingPageFooter
        consultationDuration={20}
        buttonLabel="Commencer"
        onClick={onNext}
      />
    </>
  );
};
